export function formatearPrecio(valor, conSimbolo = true) {
  if (valor === null || valor === undefined || valor === "") {
    return "";
  }

  const numero = Number(valor);
  if (isNaN(numero)) {
    return "";
  }

  const formatted = Math.round(numero)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  return conSimbolo ? `$${formatted}` : formatted;
}